var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopyIconBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#323232",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M12.627 9.675v3.15c0 2.625-1.05 3.675-3.675 3.675h-3.15c-2.625 0-3.675-1.05-3.675-3.675v-3.15C2.127 7.05 3.177 6 5.802 6h3.15c2.625 0 3.675 1.05 3.675 3.675"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#292D32",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M17.127 5.175v3.15c0 2.625-1.05 3.675-3.675 3.675h-.825V9.675C12.627 7.05 11.577 6 8.952 6H6.627v-.825c0-2.625 1.05-3.675 3.675-3.675h3.15c2.625 0 3.675 1.05 3.675 3.675"
})));
export default SvgCopyIconBlack;